<template>
  <div>
    <div class="row py-1 border-top align-items-center">
      <div class="col-1">
        <log-status :status="event.status"/>
      </div>
      <div class="col-3">
        <log-type :event="event"/>
      </div>
      <div class="col-3">
        <router-link v-if="event.channel_id"
                     :to="{ name: 'administration.channel-detail.info', params: {id: event.channel_id}}">
          {{event.channel_id}}
        </router-link>
      </div>
      <div class="col-3">
        {{event.timestamp | moment('YYYY-MM-DD HH:mm:ss')}}
      </div>
      <div class="col-2 text-right">
        <b-btn v-b-toggle="`multiCollapse${index}`"
               variant="button"
               class="btn btn-outline-primary btn-sm">
          {{label}}
        </b-btn>
      </div>
    </div>
    <b-collapse
      v-bind:id="`multiCollapse${index}`"
      @show="show"
      @hide="hide"
      class="row small">
      <div class="col">
        <div class="border-top px-1 pb-4">
          <component :is="detailComponent" :event="event"/>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
  import LogStatus from '@/components/administration/log/common/log-item/LogStatus'
  import LogType from '@/components/administration/log/common/log-item/LogType'
  import DetailMessageReceived from '@/components/administration/log/common/log-item/DetailMessageReceived'
  import DetailMessageSent from '@/components/administration/log/common/log-item/DetailMessageSent'
  import DetailWebhook from '@/components/administration/log/common/log-item/DetailWebhook'
  import DetailMessageIntegration from '@/components/administration/log/common/log-item/DetailMessageIntegration'

  export default {
    components: {
      DetailMessageReceived,
      DetailMessageSent,
      DetailWebhook,
      DetailMessageIntegration,
      LogStatus,
      LogType
    },

    props: {
      event: {
        type: Object,
        required: true
      },
      index: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        shown: false
      }
    },

    computed: {
      label() {
        if (this.shown) return 'Hide Detail'

        return 'Show Detail'
      },
      detailComponent() {
        if (this.event.type === 'webhook_sent') return 'detail-webhook'
        if (this.event.type === 'message_sent') return 'detail-message-sent'
        if (this.event.type === 'message_received') return 'detail-message-received'
        if (this.event.type === 'integration_forwarded') return 'detail-message-integration'
      }
    },

    methods: {
      show() {
        this.shown = true
      },
      hide() {
        this.shown = false
      }
    }
  }
</script>
